import React from 'react'
import Grid from '@material-ui/core/Grid'
import QuestionContainer from './QuestionContainer'
import FormDateQuestion from './FormDateQuestion'

export default ({
	question,
	position,
	positionDisplay,
	validators,
	disabled,
	onQuestionValueChanged,
	isBilateral,
	isBilateralFullInfo,
	displayInstructionAsIcon,
	uniqueKey
}) => {
	const isLabelContainerPreserved = !!isBilateral && !!isBilateralFullInfo
	const name = `answers.date._${question.uniqueId}._${uniqueKey ?? ''}`

	const handleValueChanged = (value) => {
		onQuestionValueChanged(question, value)
	}

	return (
		<Grid>
			<QuestionContainer
				data-testid="question-container-date"
				title={`${question.title}`} titleRequered = {`${question.isOptional ? '' : ' *'}`}
				position={position}
				positionDisplay={positionDisplay}
				instructions={question.instructions}
				isBilateral={isBilateral}
				displayInstructionAsIcon={displayInstructionAsIcon}
				children={
					<Grid
						container
					>
						{
							!!isLabelContainerPreserved
							&& <Grid xs={6} />
						}
						<Grid
							item
							xs={isLabelContainerPreserved ? 6 : 12}
						>
							<FormDateQuestion
								data-testid="question-container-date-field"
								disabled={disabled}
								style={{
									backgroundColor: 'white',
									color: 'black'
								}}
								variant='filled'
								name={name}
								validators={validators}
								onValueChange={handleValueChanged}
							/>
						</Grid>
					</Grid>
				}
			/>
		</Grid>
	)
}
